// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 781 ? "form-schema-jsuites" : chunkId) + "." + {"286":"7358cae2","781":"06778531","987":"7358cae2"}[chunkId] + ".chunk.css";
};